import { SoftwareAppSchema } from '@/shared/seo';
import { APP_IDS, SITE_URL } from '@/shared/site';
import { MEMBERSHEEP_APP_STORE_URL } from '@/membersheep/config';
import { MS_LOCALES, MS_PAGES, msCopyFor, msPath, useMsCopy } from '@/membersheep/i18n';
import memberSheepIcon from '@/membersheep/assets/membersheep-512.png';

/** The MemberSheep app's full entity, on its home page in both locales. */
const MsAppSchema = () => {
  const copy = useMsCopy();

  return (
    <SoftwareAppSchema
      id={APP_IDS.memberSheep}
      name="MemberSheep"
      url={SITE_URL + msPath('en', MS_PAGES.home)}
      description={copy.schema.description}
      operatingSystem="iOS 17 or later"
      applicationCategory="UtilitiesApplication"
      inLanguage={MS_LOCALES.map((locale) => msCopyFor(locale).htmlLang)}
      featureList={copy.schema.featureList}
      downloadUrl={MEMBERSHEEP_APP_STORE_URL ? [MEMBERSHEEP_APP_STORE_URL] : undefined}
      image={SITE_URL + memberSheepIcon}
    />
  );
};

export default MsAppSchema;
